exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".locale-name-area[data-v-2f8f9ed0]{min-width:120px}.original-language[data-v-2f8f9ed0]{font-size:.7rem;margin-left:5px;font-weight:700;color:#783498}", ""]);

